import { HI } from "./translations-hi";
import { AR } from "./translations-ar";
import { ES } from "./translations-es";
import { RU } from "./translations-ru";

export const LANGS = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिन्दी" },
    { code: "ar", label: "العربية" },
    { code: "es", label: "Español" },
    { code: "ru", label: "Русский" },
];

export const DICTIONARIES = { hi: HI, ar: AR, es: ES, ru: RU };
